import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import LaddaButton from "../../../components/buttons/laddaButton";
import { Grid } from "@mui/material";
import CharacterCounter from "../../../components/characterCounter";
import FormTextField from "../../../components/textField/formTextField";
import ModalComponent from "../../../components/modals";
import FormSelect from "../../../components/selects/formSelect";
import * as yup from "yup";
import { getCurrentDate } from "../../../services/dateService";

const ReassignmentEngineer = ({
  open,
  close,
  selectData,
  data,
  onInput,
  userData
}) => {
  const validationSchema = yup.object().shape({
    engineerInCharge: yup.string().required("Este campo es obligatorio"),
    reassignment_reason: yup.string().required("Este campo es obligatorio")
  });

  const {
    control,
    reset,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const setValuesEnginner = () => {
    const currentEngineer = selectData.find(
      (engineer) => String(engineer.value) === String(data.engineer_id)
    );
    setValue("engineerInCharge", currentEngineer?.value ?? "");
  };

  const onSubmit = (formData) => {
    const dataToSend = {
      user_id: userData.id,
      service_order_id: data.service_order_id,
      engineer_id: formData.engineerInCharge,
      reassignment_reason: formData.reassignment_reason,
      currentDate: getCurrentDate(),
    };
    onInput(dataToSend);
    reset();
  };

  const handleClose = () => {
    reset();
    close();
  };

  useEffect(() => {
    if (!data) return;
    setValuesEnginner();
  }, [open]);

  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      title={`Nuevo Ingeniero a cargo para ${data?.service_order_name} / ${data?.engineer_name}`}
      width="600px"
      actions={<></>}
    >
      <form>
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <FormSelect
              name="engineerInCharge"
              control={control}
              label="Seleccionar un ingeniero a cargo:"
              options={selectData}
              error={errors.engineerInCharge}
              margin={"0"}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <div>
              <div>
                <FormTextField
                  name={"reassignment_reason"}
                  label="Motivo:"
                  labelColor={"#333333"}
                  control={control}
                  isTextArea={true}
                  error={errors.reassignment_reason}
                  maxLength={250}
                  rows={3}
                  margin={"0"}
                />
              </div>
              <div>
                <CharacterCounter
                  name={"reassignment_reason"}
                  control={control}
                  maxLength={250}
                />
              </div>
            </div>
          </Grid>
        </Grid>
        <div className="j-center">
          <LaddaButton
            fontSize={"12px"}
            height={"32px"}
            variant="contained"
            margin={"20px 0"}
            onClick={handleSubmit(onSubmit)}
          >
            <p className="button_text">Guardar</p>
          </LaddaButton>
        </div>
      </form>
    </ModalComponent>
  );
};

export default ReassignmentEngineer;
